import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
})

function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token }
}

export default {
  /** All wishes across customers, sorted by due date (soonest first). */
  listAll() {
    return apiClient.get('/wishes', { headers: authHeaders() })
  },

  list(customerId) {
    return apiClient.get(`/customers/${customerId}/wishes`, { headers: authHeaders() })
  },

  get(customerId, wishId) {
    return apiClient.get(`/customers/${customerId}/wishes/${wishId}`, { headers: authHeaders() })
  },

  create(customerId, payload) {
    return apiClient.post(`/customers/${customerId}/wishes`, payload, { headers: authHeaders() })
  },

  update(customerId, wishId, payload) {
    return apiClient.patch(`/customers/${customerId}/wishes/${wishId}`, payload, { headers: authHeaders() })
  },

  fulfill(customerId, wishId) {
    return apiClient.post(`/customers/${customerId}/wishes/${wishId}/fulfill`, {}, { headers: authHeaders() })
  },

  destroy(customerId, wishId) {
    return apiClient.delete(`/customers/${customerId}/wishes/${wishId}`, { headers: authHeaders() })
  },

  createComment(customerId, wishId, body) {
    return apiClient.post(`/customers/${customerId}/wishes/${wishId}/comments`, { body }, { headers: authHeaders() })
  },

  updateComment(customerId, wishId, commentId, body) {
    return apiClient.patch(
      `/customers/${customerId}/wishes/${wishId}/comments/${commentId}`,
      { body },
      { headers: authHeaders() }
    )
  },

  destroyComment(customerId, wishId, commentId) {
    return apiClient.delete(
      `/customers/${customerId}/wishes/${wishId}/comments/${commentId}`,
      { headers: authHeaders() }
    )
  },

  listAttachments(customerId, wishId) {
    return apiClient.get(`/customers/${customerId}/wishes/${wishId}/attachments`, { headers: authHeaders() })
  },

  presignAttachment(customerId, wishId, { filename, content_type }) {
    return apiClient.post(
      `/customers/${customerId}/wishes/${wishId}/attachments/presign`,
      { filename, content_type },
      { headers: authHeaders() }
    )
  },

  createAttachment(customerId, wishId, { key, filename, content_type, byte_size }) {
    return apiClient.post(
      `/customers/${customerId}/wishes/${wishId}/attachments`,
      { key, filename, content_type, byte_size },
      { headers: authHeaders() }
    )
  },

  destroyAttachment(customerId, wishId, attachmentId) {
    return apiClient.delete(
      `/customers/${customerId}/wishes/${wishId}/attachments/${attachmentId}`,
      { headers: authHeaders() }
    )
  }
}
